exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".src-components-UserSelection-___style__container___21wJw {\n  position: relative;\n  min-width: 320px; }\n\n.src-components-UserSelection-___style__input___1d-j4 {\n  border: none;\n  outline: none;\n  padding: 6px 4px; }\n", ""]);

// exports
exports.locals = {
	"container": "src-components-UserSelection-___style__container___21wJw",
	"input": "src-components-UserSelection-___style__input___1d-j4"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./node_modules","./node_modules/grommet/node_modules"]}!./src/components/UserSelection/style.scss
// module id = 400
// module chunks = 0